import { render, staticRenderFns } from "./UiSwitch.vue?vue&type=template&id=7fc433cd"
import script from "./UiSwitch.vue?vue&type=script&lang=js"
export * from "./UiSwitch.vue?vue&type=script&lang=js"
import style0 from "./UiSwitch.vue?vue&type=style&index=0&id=7fc433cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports